import React from "react";
import PropTypes from "prop-types";
import Immutable, {
    OrderedMap,
    Map,
    List
} from "immutable";
import { Row, Col, Card, Collapse, Tag, Button, Spin, Form, message, Select } from "antd";
import QueryString from "query-string";
import { CompanyService as CompanyLosService } from "services/index";
import RiskControlForm from "../../../forms/mpa-forms/risk-control-form";
import SchemeControlForm from "../../../forms/mpa-forms/scheme-control-form";
import OnboardingControlForm from "../../../forms/mpa-forms/onboarding-control-form";
import DisbursalControlForm from "../../../forms/mpa-forms/disbursal-control-form";
import AnchorFeesForm from "../../../forms/mpa-forms/anchor-fees-form";
import CompanyBackgroundForm from "../../../forms/mpa-forms/company-background-form";
import CompanyFinancialsForm from "../../../forms/mpa-forms/company-financials-form";
import DeviationMatrixForm from "../../../forms/mpa-forms/deviation-matrix-form";
import {
    fetchDocumentTypes,
    updateMpaDetails
} from "store/actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import MeetingHistory from "../meeting-history";
import { INPUT_TYPES } from "constants/index";
import { STATE_STATUS } from "constants/state-status";
import {
    fieldGenerator,
    getErrorOnField,
} from "utilities/form";
import moment from "moment";
import { PRODUCT_DETAIL_FIELDS } from 'constants/form-fields';

const { Panel } = Collapse;




const formEnums = new Map({
    companyBackground: {
        id: 1,
        name: "Company Background",
        approved_key: "is_company_background_approved",
        user_key: "company_background_by_id",
        statusKey: "company_background_status",
        subHeader: "Input the Company Background"
    },
    companyFinancials: {
        id: 2,
        name: "Company Financials",
        approved_key: "is_company_background_approved",
        user_key: "company_financials_by_id",
        statusKey: "company_financials_status",
        subHeader: "Input the Company Financials"
    },
    deviationMatrixUpload: {
        id: 3,
        name: "Deviation Matrix Upload",
        approved_key: "is_deviation_matrix_approved",
        user_key: "deviation_matrix_approved_by_id",
        statusKey: "deviation_matrix_status",
        subHeader: "Upload and approve the deviation matrix file"
    },
    dbRiskControl: {
        id: 4,
        name: "DB Risk Controls",
        approved_key: "is_db_risk_controls_approved",
        user_key: "db_risk_controls_approved_by_id",
        statusKey: "db_risk_controls_status",
        subHeader: "Define Program risk controls"
    },
    schemeControls: {
        id: 5,
        name: "Scheme Controls",
        approved_key: "is_scheme_controls_approved",
        user_key: "scheme_controls_approved_by_id",
        statusKey: "scheme_controls_status",
        subHeader: "Define scheme ranges for distributor controls"
    },
    onboardingControls: {
        id: 6,
        name: "Onboarding Controls",
        approved_key: "is_onboarding_controls_approved",
        user_key: "onboarding_controls_approved_by_id",
        statusKey: "onboarding_controls_status",
        subHeader: "Define documents required for onboarding for seller and buyer"
    },
    disbursalControls: {
        id: 7,
        name: "Disbursal Controls",
        approved_key: "is_disbursal_controls_approved",
        user_key: "disbursal_controls_approved_by_id",
        statusKey: "disbursal_controls_status",
        subHeader: "R2D Must have Controls"
    },
    anchorFees: {
        id: 8,
        name: "Anchor Fees",
        approved_key: "is_anchor_fees_approved",
        user_key: "anchor_fees_approved_by_id",
        statusKey: "anchor_fees_status",
        subHeader: "Set the program fee decided with the anchor for progcap program"
    },
})

const getApprovalDetails = new OrderedMap({
    approval_date: {
        className: "form-field fb-30 mr-3perc",
        type: INPUT_TYPES.DATE,
        label: "Approval Date",
        rules: [
            {
                required: true,
                message: "Approval Date is Required"
            },
        ],
        category: 4
    },
    ccm_meeting_date: {
        className: "form-field fb-30",
        type: INPUT_TYPES.DATE,
        label: "CCM Meeting Date",
        rules: [
            {
                required: true,
                message: "CCM Meeting Date is Required"
            },
        ],
        category: 4
    },
    eml_file: {
        className: "form-field fb-30",
        type: INPUT_TYPES.FILE,
        label: "Email file upload",
        accept: "message/rfc822",
        rules: [
            {
                required: true,
                message: "Email file upload is Required"
            },
        ],
        fileList: [],
        showUploadList: true,
        category: 4
    },
});


class MpaRequest extends React.Component {
    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);
    approvalDetailsFormFields = getApprovalDetails;

    state = {
        salesManagers: [],
        gstin_address_fetch: false,
        gstin_address: null,
        mpaApiData: null,
        loading: true,
        deviationMatrixList: List(),
        meetingHistoryDrawerView: false,
    };

    componentDidMount() {
        CompanyLosService.deviationMatrixList(this.props.currentMpaId)
            .then((resp) => {
                this.setState({
                    deviationMatrixList: List(resp.data)
                })
            })
            .catch((err) => {
                console.log("error", err);
            })
        this.props.fetchDocumentTypes(this.props.companyId);

    }

    updateDeviationMatrixList = () => {
        CompanyLosService.deviationMatrixList(this.props.currentMpaId)
            .then((resp) => {
                this.setState({
                    deviationMatrixList: List(resp.data)
                }, () => {
                    this.fetchMpaDetails();
                })
            })
            .catch((err) => {
                console.log("error", err);
            })
    }

    componentDidUpdate(prevProps) {
        if (prevProps.mpaStatus == STATE_STATUS.FETCHING && this.props.mpaStatus == STATE_STATUS.FETCHED) {
            message.success("Details Updated Successfully");
            this.fetchMpaDetails();
        }
    }

    fetchMpaDetails = () => {
        const searchParams = QueryString.parse(window.location.search);
        this.props.fetchWorkflowCaseDetail(searchParams.action_detail_id);
    }


    saveMpaDetails = (data) => {
        this.props.updateMpaDetails(data, this.props.currentMpaId);
    }

    approveMpaRequest = (key) => {
        const data = {
            [formEnums.getIn([key, "approved_key"])]: true,
            [formEnums.getIn([key, "user_key"])]: this.props.userId
        }
        this.props.updateMpaDetails(data, this.props.currentMpaId);
    }

    

    deleteSlab = (slabId) => {
        CompanyLosService.deleteSlab(slabId)
            .then((_) => {
                this.fetchMpaDetails();

            })
    }

    saveDraft = (e) => {
        e.preventDefault();
        const formValues = {}
        const formFields = PRODUCT_DETAIL_FIELDS;

        formFields.forEach((field, fieldName) => {
            formValues[fieldName] = this.props.form.getFieldValue(fieldName);
        });

        this.saveMpaDetails(formValues);
    }

    onSubmitEmlFile = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, { users, bank_details, ...restValues }) => {
            if (err) {
                return;
            }
            const formValues = {};
            let formDataJson = new FormData();
            const formFields = this.approvalDetailsFormFields;
            formFields.forEach((field, fieldName) => {
                formValues[fieldName] = this.props.form.getFieldValue(fieldName);
            });
            formDataJson.append("approval_date", moment(formValues['approval_date']).format("YYYY-MM-DD"))
            formDataJson.append("ccm_meeting_date", moment(formValues['ccm_meeting_date']).format("YYYY-MM-DD"))
            formDataJson.append("eml_file", formValues['eml_file'])
            this.saveMpaDetails(formDataJson)
        })

    }

    get_status_tag = (key) => {
        return <Tag color={
                    (this.get_data_from_mpa_approval(key) == "Approved" || 
                    this.props.companyBackgroundData?.size>0 && this.props.companyBackgroundData.get(key)) ? "green" : "magenta"}
                >
            {this.get_data_from_mpa_approval(key) || (this.props.companyBackgroundData?.size>0 && this.props.companyBackgroundData.get(key) ? "Approved" : "Pending Review")}
            </Tag>;
    }

    get_data_from_mpa_approval = (key) => {
        if (this.props.getCurrentMpaData) {
            return this.props.getCurrentMpaData.getIn(['mpa_approval', key]);
        }
        return ""
    }

    renderProductDetailForm = (disableFormFields) => {
        return <Col span={18} offset={3} className={"pb-5 form"}>
            <Form onSubmit={this.saveDraft}>
                <Card className="" title="Product Details" extra={<Button type="primary" htmlType="submit" disabled={disableFormFields}>Save</Button>}>
                    <Row>
                    {PRODUCT_DETAIL_FIELDS.map((field, fieldName) => {
                        const value = this.get_data_from_mpa_approval(fieldName);
                        field.disabled = disableFormFields;
                        return <Col span="8">{this.fieldGenerator(
                            fieldName,
                            { ...field, value },
                            this.getErrorOnField(fieldName)
                        )()}</Col>;
                    }).toList()}
                    </Row>
                </Card>
            </Form>
        </Col>
    }

    renderCCMForm = (disableFormFields) => {
        return this.props.getCurrentMpaData && [50, 51, 52, 53].includes(this.props.getCurrentMpaData.getStageIDV2()) && <Col span={18} offset={3} className={"pb-5 mt-10"}>
            <Card title="Approval Details" >
                <Form onSubmit={this.onSubmitEmlFile}>
                    {this.approvalDetailsFormFields.map((field, fieldName) => {
                        const emlFile = this.props.form.getFieldValue("eml_file");
                        let fileListEml;
                        if (typeof emlFile === "string") {
                            if (emlFile?.length > 20) {
                                const firstPart = emlFile?.substring(0, 20);
                                const lastPart = emlFile?.substring(emlFile?.length - 20);
                                const shortenedUrl = `${firstPart}...${lastPart}`;
                                fileListEml = {
                                    uid: "-1",
                                    name: shortenedUrl,
                                    status: "done",
                                    url: emlFile,
                                };
                            }
                        } else if (typeof emlFile === "object") {
                            if (emlFile?.name?.length > 20) {
                                const firstPart = emlFile?.name?.substring(0, 20);
                                const lastPart = emlFile?.name?.substring(emlFile?.name?.length - 20);
                                const shortenedUrl = `${firstPart}...${lastPart}`;
                                fileListEml = {
                                    uid: "-1",
                                    name: "",
                                    status: "done",
                                    url: "",
                                };
                            }
                        }
                        else {
                            console.log("Substring not found");
                        }
                        if (fieldName === "eml_file" && emlFile) {
                            // field.disabled = true;
                            field.fileList = [fileListEml];
                            field.showUploadList = true;
                        }
                        if (fieldName === "eml_file" && emlFile && typeof emlFile === "object") {
                            // field.disabled = true;
                            field.fileList = [];
                            field.showUploadList = false;
                        }
                        field.disabled = disableFormFields || [51, 52, 53].includes(this.props.getCurrentMpaData.getStageIDV2());
                        return <Col span="8">{this.fieldGenerator(
                            fieldName,
                            field,
                            this.getErrorOnField(fieldName)
                        )()}</Col>;
                    }).toList()}
                    <Button className="float-right" htmlType="submit" type="primary" disabled={disableFormFields || this.get_data_from_mpa_approval("eml_file") || [51, 52, 53].includes(this.props.getCurrentMpaData.getStageIDV2())}>Submit</Button>
                </Form>
            </Card>
        </Col>
    }


    render() {
        const mpaApprovalData = this.props.getCurrentMpaData;
        const {userGroups} = this.props;
        const current_user = this.props.getCurrentMpaData && this.props.getCurrentMpaData.getAssignedUser() && this.props.getCurrentMpaData.getAssignedUser()['id']
        const checkRiskApprover = userGroups.includes(8);
        let disableFormFields = false;
        if(checkRiskApprover){
            if(mpaApprovalData.getStageIDV2() == 53 && current_user == this.props.userId){
                disableFormFields  = false
            }else if(current_user != this.props.userId){
                disableFormFields = true
            }else if(current_user == this.props.userId && [51, 52].includes(mpaApprovalData && mpaApprovalData.getStageIDV2())){
                disableFormFields = true
            }
        }else if(([51, 52, 53].includes(mpaApprovalData && mpaApprovalData.getStageIDV2()) ||  current_user != this.props.userId)){
            disableFormFields = true;
        }else{
            disableFormFields = false;
        }
    // Not to show message on anchor anboarding case and show only on anchor. This tab is only visible to anchors
        return <Row>
            {!this.props.anchorOnboarding && <Row className="mb-10">
                <Col span={18} offset={3} className={"pb-5 mt-10"}>
                    <Card>
                        <div style={{ textAlign: "left" , display: "flex", justifyContent: "space-between", alignItems: "center"}}  >
                        <p style={{marginBottom : 0}} className="redirect-link" >To edit/update Master Program Agreement details, please go through the anchor onboarding process.</p>
                            <Button style={{ paddingLeft: 5 }} type="link" onClick={() => this.props.history.push("/app/anchor-onboarding/?stage=docs_pending")}>Click Here</Button>
                        </div>

                    </Card>
                </Col>
            </Row>}
            {this.state.meetingHistoryDrawerView && <MeetingHistory
                companyId={this.props.companyId}
                visible={this.state.meetingHistoryDrawerView}
                closeModal={() => this.setState({ meetingHistoryDrawerView: false })}
                umsCompanyId={this.props.profile.getIn(['data', 'ums_company_id'])}
            />}
            <Row>
                <Col span={18} offset={3} className={"pb-5 text-right"}>
                    <Button disabled={disableFormFields} onClick={() => this.setState({ meetingHistoryDrawerView: true })}>Meeting History</Button>
                </Col>
            </Row>
            <Spin spinning={this.props.onboardingCaseDetailStatus == STATE_STATUS.FETCHING || this.props.mpaStatus == STATE_STATUS.FETCHING}>
                <Row>
                    {this.renderProductDetailForm(disableFormFields)}
                    {this.renderCCMForm(disableFormFields)}
                    <Col span={18} offset={3} className={"pb-5 mt-10"}>
                        <Card title="Master Program Agreement Details" >
                            <Collapse
                                className="ant-d-collapse-padding custom-header-antd"
                                bordered={false}
                                expandIconPosition={"right"}
                            >
                                <Panel
                                    header={
                                        <div className="displayInline">
                                            <div>{formEnums.getIn(["companyBackground", "name"])}</div>
                                            <div className="subheader">{formEnums.getIn(["companyBackground", "subHeader"])}</div>
                                        </div>
                                    }
                                    key="1" extra={this.get_status_tag('is_company_background_details_completed')}>
                                    <CompanyBackgroundForm
                                        currentMpaId={this.props.currentMpaId}
                                        values={mpaApprovalData && new Map(mpaApprovalData.get("mpa_approval"))}
                                        companyBackgroundData={this.props.companyBackgroundData}
                                        companyId={this.props.companyId}
                                    />
                                </Panel>
                                <Panel
                                    header={
                                        <div className="displayInline">
                                            <div>{formEnums.getIn(["companyFinancials", "name"])}</div>
                                            <div className="subheader">{formEnums.getIn(["companyFinancials", "subHeader"])}</div>
                                        </div>
                                    }
                                    key="2" extra={this.get_status_tag('is_company_financial_details_completed')}>
                                    <CompanyFinancialsForm
                                        currentMpaId={this.props.currentMpaId}
                                        values={mpaApprovalData && new Map(mpaApprovalData.get("mpa_approval"))}
                                        companyBackgroundData={this.props.companyBackgroundData}
                                        companyId={this.props.companyId}
                                    />
                                </Panel>
                                <Panel
                                    header={
                                        <div className="displayInline">
                                            <div>{formEnums.getIn(["deviationMatrixUpload", "name"])}</div>
                                            <div className="subheader">{formEnums.getIn(["deviationMatrixUpload", "subHeader"])}</div>
                                        </div>
                                    }
                                    key="3" extra={this.get_status_tag(formEnums.getIn(["deviationMatrixUpload", "statusKey"]))}>
                                    <DeviationMatrixForm
                                        updateDeviationMatrixList={this.updateDeviationMatrixList}
                                        mpaData={Immutable.fromJS(this.state.mpaApiData)}
                                        salesPermission={this.props.permissions.get("can_mpa_initiate")}
                                        creditPermission={this.props.permissions.get("can_mpa_approve")}
                                        companyId={this.props.companyId}
                                        profile={this.props.profile}
                                        values={mpaApprovalData && new Map(mpaApprovalData.get("mpa_approval"))}
                                        matrixData={this.state.deviationMatrixList}
                                        approveDetails={this.approveMpaRequest.bind(null, "deviationMatrixUpload")}
                                        approveDisabled={this.get_data_from_mpa_approval(formEnums.getIn(["deviationMatrixUpload", "approved_key"])) || mpaApprovalData.getStageIDV2() == 48}
                                        mpaApprovalId={this.get_data_from_mpa_approval("id")}
                                        disableFields={disableFormFields}
                                    />
                                </Panel>
                                <Panel
                                    header={
                                        <div className="displayInline">
                                            <div>{formEnums.getIn(["dbRiskControl", "name"])}</div>
                                            <div className="subheader">{formEnums.getIn(["dbRiskControl", "subHeader"])}</div>
                                        </div>
                                    }
                                    key="4" extra={this.get_status_tag(formEnums.getIn(["dbRiskControl", "statusKey"]))}>
                                    <RiskControlForm
                                        approveDisabled={this.get_data_from_mpa_approval(formEnums.getIn(["dbRiskControl", "approved_key"])) || mpaApprovalData.getStageIDV2() == 48}
                                        approveDetails={this.approveMpaRequest.bind(null, "dbRiskControl")}
                                        updateDetail={this.saveMpaDetails}
                                        values={mpaApprovalData && new Map(mpaApprovalData.get("mpa_approval"))}
                                        disableFields={disableFormFields}
                                    />
                                </Panel>
                                <Panel
                                    header={
                                        <div className="displayInline">
                                            <div>{formEnums.getIn(["schemeControls", "name"])}</div>
                                            <div className="subheader">{formEnums.getIn(["schemeControls", "subHeader"])}</div>
                                        </div>
                                    }
                                    key="5" extra={this.get_status_tag(formEnums.getIn(["schemeControls", "statusKey"]))}>
                                    <SchemeControlForm
                                        approveDisabled={this.get_data_from_mpa_approval(formEnums.getIn(["schemeControls", "approved_key"])) || mpaApprovalData.getStageIDV2() == 48}
                                        approveDetails={this.approveMpaRequest.bind(null, "schemeControls")}
                                        updateDetail={this.saveMpaDetails}
                                        values={mpaApprovalData && new Map(mpaApprovalData.get("mpa_approval"))}
                                        disableFields={disableFormFields}
                                    />
                                </Panel>
                                <Panel
                                    header={
                                        <div className="displayInline">
                                            <div>{formEnums.getIn(["onboardingControls", "name"])}</div>
                                            <div className="subheader">{formEnums.getIn(["onboardingControls", "subHeader"])}</div>
                                        </div>
                                    }
                                    key="6" extra={this.get_status_tag(formEnums.getIn(["onboardingControls", "statusKey"]))}>
                                    <OnboardingControlForm
                                        approveDisabled={this.get_data_from_mpa_approval(formEnums.getIn(["onboardingControls", "approved_key"])) || mpaApprovalData.getStageIDV2() == 48}
                                        approveDetails={this.approveMpaRequest.bind(null, "onboardingControls")}
                                        docMasterList={this.props.docMasterList}
                                        updateDetail={this.saveMpaDetails}
                                        values={mpaApprovalData && new Map(mpaApprovalData.get("mpa_approval"))}
                                        disableFields={disableFormFields}
                                    />
                                </Panel>
                                <Panel
                                    header={
                                        <div className="displayInline">
                                            <div>{formEnums.getIn(["disbursalControls", "name"])}</div>
                                            <div className="subheader">{formEnums.getIn(["disbursalControls", "subHeader"])}</div>
                                        </div>
                                    }
                                    key="7" extra={this.get_status_tag(formEnums.getIn(["disbursalControls", "statusKey"]))}>
                                    <DisbursalControlForm
                                        approveDisabled={this.get_data_from_mpa_approval(formEnums.getIn(["disbursalControls", "approved_key"])) || mpaApprovalData.getStageIDV2() == 48}
                                        approveDetails={this.approveMpaRequest.bind(null, "disbursalControls")}
                                        updateDetail={this.saveMpaDetails}
                                        values={mpaApprovalData && new Map(mpaApprovalData.get("mpa_approval"))}
                                        disableFields={disableFormFields}
                                    />
                                </Panel>
                                <Panel
                                    header={
                                        <div className="displayInline">
                                            <div>{formEnums.getIn(["anchorFees", "name"])}</div>
                                            <div className="subheader">{formEnums.getIn(["anchorFees", "subHeader"])}</div>
                                        </div>
                                    }
                                    key="8" extra={this.get_status_tag(formEnums.getIn(["anchorFees", "statusKey"]))}>
                                    <AnchorFeesForm
                                        currentMpaId={this.props.currentMpaId}
                                        approveDisabled={this.get_data_from_mpa_approval(formEnums.getIn(["anchorFees", "approved_key"])) || mpaApprovalData.getStageIDV2() == 48}
                                        deleteSlab={this.deleteSlab}
                                        fetchMpaDetails={this.fetchMpaDetails}
                                        approveDetails={this.approveMpaRequest.bind(null, "anchorFees")}
                                        updateDetail={this.saveMpaDetails}
                                        values={mpaApprovalData && new Map(mpaApprovalData.get("mpa_approval"))}
                                        disableFields={disableFormFields}
                                    />
                                </Panel>
                            </Collapse>
                        </Card>
                    </Col>
                </Row>
            </Spin>


        </Row>;
    }
}


MpaRequest.propTypes = {
    location: PropTypes.object,
    history: PropTypes.object,
    companyId: PropTypes.string,
    profile: PropTypes.object,
    permissions: PropTypes.object,
    detail: PropTypes.object,
    updateCompanyLosDetail: PropTypes.func,
    user: PropTypes.object,
    fetchDocumentTypes: PropTypes.func,
};



const mapStateToProps = (state, props) => ({
    docMasterList: state.documents.getIn(["companyDocMasterList", "data"]),
    docMasterListStatus: state.documents.getIn([
        "companyDocMasterList",
        "status"
    ]),
    userId: state.user.getIn(["data", "id"]),
    mpaStatus: state.companies.get('mpaStatus'),
    mpaData: state.companies.getIn(['mpaStatus', 'mpaLoader']),
    userGroups: state.user && state.user.getIn(["data", "groups"]).map(_ => _.id),
});

const mapDispatchToProps = dispatch =>
    bindActionCreators({
        fetchDocumentTypes,
        updateMpaDetails
    }, dispatch);


const MpaRequestWithRedux = connect(
    mapStateToProps,
    mapDispatchToProps
)(MpaRequest);

const MpaRequestWithReduxAndForm = Form.create({
    name: 'mpa_request_form', // Provide a name for the form
    // Pass the initial values to the form
    mapPropsToFields(props) {
        const { getCurrentMpaData } = props;
        const initialValues = {};
        if (getCurrentMpaData) {
            PRODUCT_DETAIL_FIELDS.forEach((field, fieldName) => {
                initialValues[fieldName] = Form.createFormField({
                    value: getCurrentMpaData['mpa_approval'][fieldName],
                });
            });
            getApprovalDetails.forEach((field, fieldName) => {
                if (fieldName == "approval_date") {
                    return initialValues[fieldName] = Form.createFormField({
                        value:getCurrentMpaData.getIn(['mpa_approval', fieldName]) ?  moment(getCurrentMpaData.getIn(['mpa_approval', fieldName]), "YYYY_MM_DD")  :  "",
                    });
                }
                if (fieldName == "ccm_meeting_date") {
                    return initialValues[fieldName] = Form.createFormField({
                        value: getCurrentMpaData.getIn(['mpa_approval', fieldName]) ? moment(getCurrentMpaData.getIn(['mpa_approval', fieldName]), "YYYY_MM_DD") : "",
                    });
                }

                initialValues[fieldName] = Form.createFormField({
                    value: getCurrentMpaData['mpa_approval'][fieldName],
                });
            });
        }




        return initialValues;
    },
})(MpaRequestWithRedux);

export default MpaRequestWithReduxAndForm;
